import { Component } from "react";
import PropTypes from "prop-types";

export class Paging extends Component {
  static propTypes = {
    itemsLength: PropTypes.number,
    perPage: PropTypes.number,
    activePage: PropTypes.number,
    changePage: PropTypes.func,
    children: PropTypes.func
  };

  goForward = () => {
    const { activePage, changePage, itemsLength, perPage } = this.props;
    if (Math.ceil(itemsLength / perPage) > activePage + 1) {
      changePage(activePage + 1);
    }
  };

  goBack = () => {
    const { activePage, changePage } = this.props;
    if (activePage > 0) {
      changePage(activePage - 1);
    }
  };

  render() {
    const { activePage, children, itemsLength, perPage } = this.props;
    const totalPages = Math.ceil(itemsLength / perPage);
    return children({
      goBack: this.goBack,
      goForward: this.goForward,
      activePage,
      totalPages
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/Paging.js